import React from "react";
//import { NavLink } from "react-router-dom";

function Mobile({ isOpen, setIsOpen}) {
  return (
  <div className="bg-white h-[100vh] w-[60vw] absolute right-0 top-6 py-5 px-12 flex flex-col ">
    <div className="text-3xl" onClick={() => setIsOpen(!isOpen)}>
      <i class="fi-rr-cross-circle"></i>
    </div>
    <div className="flex flex-row w-full pt-6 justify-start items-center">
    <a href="#projects" className="flex flex-row pl-0 text-2xl font-medium text-pink-800">
          <i class="fi-rr-edit-alt option-icon mr-4"></i>Projects
        </a>
    </div>
    <div className="flex flex-row w-full pt-6 justify-start items-center">
        <a href="#skills" className="flex flex-row pl-0 text-2xl font-medium text-pink-800">
        <i class="fi-rr-laptop option-icon mr-4"></i>Skills
        </a>
    </div>
    <div className="flex flex-row w-full pt-6 justify-start items-center">
        <a href="#work" className="flex flex-row pl-0 text-2xl font-medium text-pink-800">
        <i class="fi-rr-briefcase option-icon mr-4"></i>Work
        </a>
    </div>
    <div className="flex flex-row w-full pt-6 justify-start items-center">
        <a href="#contact" className="flex flex-row pl-0 text-2xl font-medium text-pink-800">
        <i class="fi fi-rr-user option-icon mr-4"></i>Contact
        </a>
    </div>
  </div>
  );
}

export default Mobile;